import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const routeParamGuard: (param: string) => CanActivateFn = (param: string) => (route) => {
  const router: Router = inject(Router);
  const hashParam = route.params[param];
  return !!hashParam || router.parseUrl('/');
};
